import React from 'react';
import PropType from 'prop-types';

import Button from '@Components/Button'

import './HeatmapBackToResultsButton.custom.scss';


export function getHeatmapLayoutConfig (isLaptop) {
  if (isLaptop) {
    return {
      type: 'link',
      iconClassName: 'els-btn-icon',
      size: 'tiny',
    };
  }

  return {
    type: 'tertiary',
    iconClassName: '',
    size: 'sm',
  };
}

export default function HeatmapBackToResultsButton (props) {
  const {
    isLaptop,
    toContextLabel,
    showResultsList,
  } = props;
  const {
    size,
    type,
    iconClassName,
  } = getHeatmapLayoutConfig(isLaptop);


  return (
    <Button
      onClick={()=> {
        showResultsList();
      }}
      buttonConfig={{
        className: 'result-toolbar-heatmap-back-to-results-button',
        label: toContextLabel,
        type,
        size,
        e2eName: 'heatmap-back-to-results',
      }}
      iconConfig={{
        position: 'before',
        name: 'rows',
        className: iconClassName,
      }}
    />
  );
}

HeatmapBackToResultsButton.propType = {
  isLaptop: PropType.bool.isRequired,
  toContextLabel: PropType.string.isRequired,
  showResultsList: PropType.func.isRequired,
};
